import React from 'react';
import { RootStackParamList, RootTabParamList, RootTabScreenProps } from '../types';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { View, TouchableOpacity } from 'react-native';

import { Icon } from '../components/Icon';
import tw from '../styles/tailwind';
import Text from '../components/Text';

import { useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import useActiveResidentCommunity from '../hooks/useActiveResidentCommunity';
import useStaff from '../hooks/useStaff';

/**
 * Residente
 */
import AdminCommunitiesScreen from '../screens/Main/AdminCommunitiesScreen';
import QRScannerScreen from '../screens/Main/QRScannerScreen';
import ResidentDashboard from "../screens/Community/Resident/ResidentDashboardScreen";
import AccessScreen from "../screens/Community/Resident/AccessScreen";
import ResidentFeesScreen from "../screens/Community/Resident/Fees/UnitFeesScreen";
import SettingsScreen from '../screens/Main/SettingsScreen';
import FeeDetailScreen from '../screens/Community/Resident/Fees/FeeDetailScreen';
import BankTransferPaymentScreen from '../screens/Community/Resident/Fees/PaymentCheckout/BankTransferPaymentScreen';
import GuestPassesScreen from '../screens/Community/Resident/GuestPasses/GuestPassesScreen';
import AccessAuthorizationsScreen from '../screens/Community/Resident/AccessAuthorizations/AccessAuthorizationsScreen';
import BankTransferEvidenceUploadScreen from '../screens/Community/Resident/Fees/PaymentCheckout/BankTransferEvidenceUploadScreen';
import AnnouncementDetailScreen from '../screens/Community/Resident/Announcements/AnnouncementDetailScreen';
import ResidentAnnouncementsScreen from '../screens/Community/Resident/Announcements/AnnouncementsScreen';
import PaymentMethodScreen from '../screens/Community/Resident/Fees/PaymentCheckout/PaymentMethodScreen';
import TicketsListScreen from '../screens/Community/Resident/Tickets/TicketsListScreen';
import TicketDetailScreen from '../screens/Community/Resident/Tickets/TicketDetailScreen';



const Stack = createNativeStackNavigator();
const BottomTab = createBottomTabNavigator();




export default function MainStackNavigator() {
  return (
    <Stack.Navigator>
      <Stack.Screen
        name="Home"
        component={MainBottomTabNavigator}
        options={{ headerShown: false }}
      />

      <Stack.Screen
        name="Resident.Scanner"
        component={QRScannerScreen}
        options={{ title: "", headerShown: false }}
      />

      {/* <Stack.Screen
        name="Resident.Dashboard"
        component={ResidentDashboard}
        options={{ title: "" }}
      /> */}

      <Stack.Screen
        name="Resident.Fees"
        component={ResidentFeesScreen}
        options={{ title: "", headerShown: false }}
      />

      <Stack.Screen
        name="Resident.GuestPasses.Index"
        component={GuestPassesScreen}
        options={{ title: "", headerShown: false }}
      />

      <Stack.Screen
        name="Resident.AccessAuthorizations.Index"
        component={AccessAuthorizationsScreen}
        options={{ title: "", headerShown: false }}
      />

      <Stack.Screen
        name="Resident.Announcements.Index"
        component={ResidentAnnouncementsScreen}
        options={{ title: "Comunicados", headerShown: false }}
      />

      <Stack.Screen
        name="Resident.Announcement.Detail"
        component={AnnouncementDetailScreen}
        options={{ title: "", headerShown: false }}
      />

      <Stack.Screen
        name="Resident.Fees.Detail"
        component={FeeDetailScreen}
        options={{ title: "", headerShown: false }}
      />


      {/*  */}
      <Stack.Screen
        name="Resident.UnitFeesPayment"
        component={PaymentMethodScreen}
        options={{ title: "", headerShown: false }}
      />

      <Stack.Screen
        name="Resident.UnitFeesPayment.BankTransfer"
        component={BankTransferPaymentScreen}
        options={{ title: "", headerShown: false }}
      />

      <Stack.Screen
        name="Resident.UnitFeesPayment.BankTransfer.PaymentEvidenceUpload"
        component={BankTransferEvidenceUploadScreen}
        options={{ title: "", headerShown: false }}
      />

      <Stack.Screen
        name="Resident.Tickets.Index"
        component={TicketsListScreen}
        options={{ title: "", headerShown: false }}
      />

      <Stack.Screen
        name="Resident.Tickets.Detail"
        component={TicketDetailScreen}
        options={{ title: "", headerShown: false }}
      />

    </Stack.Navigator>
  );
}




function MainTabBar({ state, descriptors, navigation }) {
  const insets = useSafeAreaInsets();

  return (
    <View style={tw.style(`row justify-between bg-white rounded-b-3xl shadow-2xl rounded-t-lg absolute bottom-0 py-0 left-0 right-0 pb-[${insets.bottom}px]`)}>
      {state.routes.map((route, index) => {
        const { options } = descriptors[route.key];
        const label =
          options.tabBarLabel !== undefined
            ? options.tabBarLabel
            : options.title !== undefined
              ? options.title
              : route.name;

        const isFocused = state.index === index;

        const onPress = () => {
          const event = navigation.emit({
            type: 'tabPress',
            target: route.key,
            canPreventDefault: true,
          });

          if (!isFocused && !event.defaultPrevented) {
            // The `merge: true` option makes sure that the params inside the tab screen are preserved
            navigation.navigate({ name: route.name, merge: true });
          }
        };

        const onLongPress = () => {
          navigation.emit({
            type: 'tabLongPress',
            target: route.key,
          });
        };

        return (
          <View
            key={route.name}
            style={tw`flex-1 flex items-center py-1 pt-2`}
          >
            <TouchableOpacity
              style={tw`items-center`}
              accessibilityRole="button"
              accessibilityState={isFocused ? { selected: true } : {}}
              accessibilityLabel={options.tabBarAccessibilityLabel}
              testID={options.tabBarTestID}
              onPress={onPress}
              onLongPress={onLongPress}
              >
              <View>
                { options.tabBarIcon({focused: isFocused}) }
              </View>

              <Text style={tw.style(`text-xs mt-4 -mb-0`, { color: isFocused ? tw.color('primary') : tw.color('gray-400') })}>
                { label}
              </Text>
            </TouchableOpacity>
          </View>
        );
      })}
    </View>
  );
}



function MainBottomTabNavigator() {
  const { communities } = useSelector(state => state.status)
  const { adminCommunities: admin_communities, guardCommunities } = useStaff()
  const { communityId: activeResidentCommunityId, setActiveCommunityId: setActiveResidentCommunityId } = useActiveResidentCommunity()

  const hasResidentCommunities = communities?.length > 0;

  // Default a la primera comunidad cuando carga la lista y no hay una activa, o
  // la activa ya no es suya (p. ej. quedó de otra sesión).
  // Antes vivía en QRScannerScreen (primera pantalla del tab); ahora aquí
  // para que aplique sin importar a qué tab entre el usuario primero.
  useEffect(() => {
    if (communities?.length > 0 && !communities.some(c => c.uuid === activeResidentCommunityId)) {
      setActiveResidentCommunityId(communities[0].uuid)
    }
  }, [communities, activeResidentCommunityId])


  return (
    <BottomTab.Navigator
      tabBar={props => <MainTabBar {...props} />}
      screenOptions={{
        tabBarActiveTintColor: tw.color('secondary'),
      }}
    >

      {/* Tab Mi Vivienda */}
      {
        hasResidentCommunities &&
          <BottomTab.Screen
            name="Main.Resident.Dashboard"
            component={ResidentDashboard}
            options={{
              title: 'Mi Vivienda',
              headerShown: false,
              tabBarIcon: ({ focused }) => <Icon
                name="navResidentMivivienda"
                variant={focused ? 'active' : 'default'}
                size={22}
                style={tw`-mb-2`}
              />,
            }}
          />
      }


      {
        hasResidentCommunities &&
          <BottomTab.Screen
            name="Main.Resident.Access"
            component={AccessScreen}
            options={{
              title: 'Accesos',
              headerShown: false,
              tabBarIcon: ({ focused }) => <Icon
                name="navResidentAccesos"
                variant={focused ? 'active' : 'default'}
                size={24}
                style={tw`-mb-2`}
              />,
            }}
          />
      }

      {/* Botón Administración (también lleva a la consola de vigilancia) */}
      {
        (admin_communities?.length > 0 || guardCommunities.length > 0) &&
          <BottomTab.Screen
            name="Main.Admin.Dashboard"
            component={AdminCommunitiesScreen}
            options={{
              title: admin_communities?.length > 0 ? 'Administración' : 'Vigilancia',
              headerShown: false,
              tabBarIcon: ({ focused }) => <Icon
                name="navViviendas"
                variant={focused ? 'green' : 'default'}
                size={22}
                style={tw`-mb-2`}
              />,
            }}
          />
      }

      {/* Tab Mi Perfil */}
      <BottomTab.Screen
        name="Main.Settings.Index"
        component={SettingsScreen}
        options={{
          title: 'Mi Perfil',
          headerShown: true,
          tabBarIcon: ({ focused }) => <Icon
            name="navPerfil"
            variant={focused ? 'active' : 'default'}
            size={22}
            style={tw`-mb-2`}
          />,
        }}
      />
    </BottomTab.Navigator>
  );
}